<div data-cy="subscription_block" class="box item-features item-features-left" [ngClass]="{ 'huge-margin-top': isFai }">
    @if (!isFai) {
        <span class="has-text-right block-actions">
            @if (showEdit) {
                <button
                    type="button"                    data-tc-action="Clic_redirection"
                    data-tc-categorie="Sortie_panier"
                    data-tc-clic="Modifier_forfait"
                    aria-label="Modifier le forfait"
                    class="link has-text-secondary is-size-7 button-clear"
                    [checkoutNavigateTo]="editUrl"
                >
                    Modifier
                </button>
            }
            <span class="is-invisible">ou</span>
            @if (showDeleteButton) {
                <button
                    type="button"                    data-tc-action="Clic_redirection"
                    data-tc-categorie="Sortie_panier"
                    data-tc-clic="Supprimer_forfait"
                    aria-label="Supprimer le forfait"
                    class="link has-text-secondary is-size-7 button-clear"
                    (click)="remove()"
                >
                    Supprimer
                </button>
            }
        </span>
    }
    <ng-template checkoutSubscriptionBlockHost></ng-template>
</div>
